//Formulario de Satisfaccion Comercial
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

const FormStyle9 = () => {
  const { t, i18n, ready } = useTranslation();
  const navigate = useNavigate(); // Inicializa el hook de navegaciónconst navigate = useNavigate(); // Inicializa el hook de navegación
    const [formData, setFormData] = useState({
      libro: '',
      contactoasesor: '',
      asesor: '',
      trato: '',
      informacion: '',
      claridad: '',
      amabilidadasesor: '',
      atenderdenuevo: '',
      precios: '',
      acompañar: '',
      abogados: '',
      ayuda: '',
      recomienda: '',
      mejorar: '',
      paisdonde: '',
      nombre: '',
      direccion: '', // Corregido 'direcion' a 'direccion'
      poblacion: '',
      cp: '',
      pais: '',
      mail: '',
      acceptTerms: false
    });
  
    const handleChange = (e) => {
      const { name, value, type, checked } = e.target;
      setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const response = await fetch('https://www.gestlifesurrogacy.com/formularios/formStyle9.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });
        if (response.ok) {
          alert('Formulario enviado con éxito');
           // Redirigir a la página /gracias/
         navigate(t('navigation_redirect', '/'));
        } else {
          throw new Error('Error al enviar el formulario');
        }
      } catch (error) {
        alert('Error al enviar el formulario: ' + error.message);
      }
    };

    if (!ready) {
      return null; // o un spinner/cargando...
    }

    const currentLanguage = i18n.language;
  
    return (
      <div className="container mt-5">
        <form onSubmit={handleSubmit} className="bg-light p-4 rounded shadow-sm">
          {/* Form Header */}
          <div className="form-header mb-4">
            <h3 className="text-center">{t('satisfaction_title')}</h3>
            <p className="text-center text-muted">{t('satisfaction_subtitle')}</p>
          </div>
  
          {/* Form Body */}
          <div className="form-body">
            {/* Book Selection */}
            {currentLanguage !== 'de' && (
            <div className="form-group mb-4">
              <label className="form-label">{t('satisfaction_book')}</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="libro"
                  value="ABC"
                  onChange={handleChange}
                  required
                  className="form-check-input"
                />
                <label className="form-check-label">
                  {t('satisfaction_book_abc')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="libro"
                  value="EMBARAZO PASO A PASO"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                  {t('satisfaction_book_emb')}
                </label>
              </div>
            </div>
          )}
  
            {/* Advisor Contact */}
            <div className="form-group mb-4">
              <label className="form-label">{t('satisfaction_quest_one')}</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="contactoasesor"
                  value="no"
                  onChange={handleChange}
                  required
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('satisfaction_answ_one')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="contactoasesor"
                  value="si"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('satisfaction_answ_two')}
                </label>
              </div>
            </div>
  
            {/* Advisor Name */}
            <div className="form-group mb-4">
              <label className="form-label">{t('satisfaction_answ_three')}</label>
              <input
                type="text"
                name="asesor"
                onChange={handleChange}
                value={formData.asesor}
                className="form-control"
              />
            </div>

            {/* Treat */}
            <div className="form-group mb-4">
              <label className="form-label">{t('treat_title')}</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="trato"
                  value="Muy correcto y amable"
                  onChange={handleChange}
                  required
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('treat_option_1')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="trato"
                  value="Correcto"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('treat_option_2')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="trato"
                  value="Indiferente"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('treat_option_3')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="trato"
                  value="Poco correcto"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('treat_option_4')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="trato"
                  value="Nada correcto"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('treat_option_5')}
                </label>
              </div>
            </div>

              {/* Info */}
              <div className="form-group mb-4">
              <label className="form-label">{t('info_title')}</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="informacion"
                  value="Mas que suficiente"
                  onChange={handleChange}
                  required
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('info_option_1')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="informacion"
                  value="Suficiente"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('info_option_2')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="informacion"
                  value="Algo insuficiente"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('info_option_3')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="informacion"
                  value="Totalmente insuficiente"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('info_option_4')}
                </label>
              </div>
            </div>

            {/* Info two*/}
            <div className="form-group mb-4">
              <label className="form-label">{t('info_clear_title')}</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="claridad"
                  value="Muy clara"
                  onChange={handleChange}
                  required
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('info_clear_option_1')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="claridad"
                  value="Algo clara"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('info_clear_option_2')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="claridad"
                  value="Poco clara"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('info_clear_option_3')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="claridad"
                  value="Nada clara"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('info_clear_option_4')}
                </label>
              </div>
            </div>

              {/* Prices*/}
              <div className="form-group mb-4">
              <label className="form-label">{t('price_title')}</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="precios"
                  value="Muy caros"
                  onChange={handleChange}
                  required
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('price_option_1')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="precios"
                  value="Caros"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('price_option_2')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="precios"
                  value="A precio de mercado"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('price_option_3')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="precios"
                  value="Baratos"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('price_option_4')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="precios"
                  value="Muy baratos"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('price_option_5')}
                </label>
              </div>
            </div>

              {/* Destination*/}
              <div className="form-group mb-4">
              <label className="form-label">{t('destination_title')}</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="acompañar"
                  value="Muy positivamente"
                  onChange={handleChange}
                  required
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('destination_option_1')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="acompañar"
                  value="Positivamente"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('destination_option_2')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="acompañar"
                  value="Mes es indiferente"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('destination_option_3')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="acompañar"
                  value="Negativamente"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('destination_option_4')}
                </label>
              </div>
            
            </div>

            {/* Lawyers*/}
            <div className="form-group mb-4">
              <label className="form-label">{t('lawyers_title')}</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="abogados"
                  value="Muy positivamente"
                  onChange={handleChange}
                  required
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('lawyers_option_1')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="abogados"
                  value="Positivamente"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('lawyers_option_2')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="abogados"
                  value="Me es indiferente"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('lawyers_option_3')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="abogados"
                  value="Negativamente"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('lawyers_option_4')}
                </label>
              </div>
            
            </div>

               {/* Help */}
               <div className="form-group mb-4">
              <label className="form-label">{t('help_title')}</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="ayuda"
                  value="Imprescindible"
                  onChange={handleChange}
                  required
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('help_option_1')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="ayuda"
                  value="Necesaria"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('help_option_2')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="ayuda"
                  value="No es muy necesaria"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('help_option_3')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="ayuda"
                  value="Es innecesaria"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('help_option_4')}
                </label>
              </div>
            
            </div>


              {/* Friend */}
              <div className="form-group mb-4">
              <label className="form-label">{t('friend_title')}</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="recomienda"
                  value="Si"
                  onChange={handleChange}
                  required
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('friend_option_1')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="recomienda"
                  value="No"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('friend_option_2')}
                </label>
              </div>
              </div>

              {/* Country */}
               <div className="form-group mb-4">
              <label className="form-label">{t('country_title')}</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="paisdonde"
                  value="USA"
                  onChange={handleChange}
                  required
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_option_1')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="paisdonde"
                  value="Grecia"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_option_2')}
                </label>
              </div>
              {/* <div className="form-check">
                <input
                  type="radio"
                  name="paisdonde"
                  value="Republica Checa"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_option_3')}
                </label>
              </div> */}
              <div className="form-check">
                <input
                  type="radio"
                  name="paisdonde"
                  value="Albania"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_option_4')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="paisdonde"
                  value="Georgia"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_option_5')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="paisdonde"
                  value="Ucrania"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_option_6')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="paisdonde"
                  value="Colombia"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_option_7')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="paisdonde"
                  value="Mexico"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_option_8')}
                </label>
              </div>
            
            </div>





          
            {/* Personal Information */}
            <div className='personal-data-container'>
            <div className="form-group mb-4">
              <label className="form-label">{t('satisfaction_personal_data')}</label>
              <input
                type="text"
                name="nombre"
                placeholder={t('name_satisf')}
                onChange={handleChange}
                value={formData.nombre}
                required
                className="form-control"
              />
              <input
                type="text"
                name="direccion"
                placeholder={t('adress_satisf')}
                onChange={handleChange}
                value={formData.direccion}
                required
                className="form-control"
              />
              <input
                type="text"
                name="poblacion"
                placeholder={t('city_satisf')}
                onChange={handleChange}
                value={formData.poblacion}
                required
                className="form-control"
              />
              <input
                type="text"
                name="cp"
                placeholder={t('cp_satisf')}
                onChange={handleChange}
                value={formData.cp}
                required
                className="form-control"
              />
              <input
                type="text"
                name="pais"
                placeholder={t('country_satisf')}
                onChange={handleChange}
                value={formData.pais}
                required
                className="form-control"
              />
              <input
                type="email"
                name="mail"
                placeholder="Email"
                onChange={handleChange}
                value={formData.mail}
                required
                className="form-control"
              />
            </div>
            </div>
  
            {/* Terms Acceptance */}
            <div className="form-group mb-4 form-check">
              <input
                type="checkbox"
                name="acceptTerms"
                onChange={handleChange}
                checked={formData.acceptTerms}
                required
                className="form-check-input"
              />
              <label className="form-check-label">
              {t('satisfaction_accept')}    
              </label>
            </div>
  
            {/* Submit Button */}
            <div className="form-group text-center">
              <button type="submit" className="btn btn-primary btn-lg">
              {t('satisfaction_send_btn')}    
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  };
  
  export default FormStyle9;